import React from 'react';

import { ScreenGo } from '@gogame/screens';

import * as CONCEPT_FAMILY from 'scenes/Gallery/GalleryPage/ConceptFamilies/view-constants';
import * as CONCEPT from 'scenes/Gallery/GalleryPage/Concepts/view-constants';
import * as CREATIVE from 'scenes/Gallery/GalleryPage/Creatives/view-constants';
import {
  AttributeItem,
  AttributeList,
} from 'scenes/Gallery/components/AttributeList';
import { PreviewFile } from 'scenes/Gallery/components/File';
import { THUMBNAIL_URL } from 'scenes/Gallery/components/File/constants';

const PreviewColumn = ({ row }) => {
  const {
    [CONCEPT_FAMILY.ID]: id,
    [CONCEPT_FAMILY.CONCEPTS_COUNT]: conceptsCount,
    [CONCEPT_FAMILY.CREATIVES_COUNT]: creativesCount,
    [CONCEPT.ORIGINAL]: original,
  } = row;

  const {
    [CREATIVE.FILE]: { [THUMBNAIL_URL]: originalFileThumbnailURL } = {},
  } = original || {};

  return (
    <ScreenGo to={`${id}`} data-cy={'Concept Details'}>
      <PreviewFile
        src={originalFileThumbnailURL}
        width={109}
        height={64}
        withOverlay={true}
        attributes={
          <AttributeList color={'common.white'} spacing={0.5} p={0.5}>
            <AttributeItem
              valueParser={'conceptsCount'}
              value={conceptsCount}
            />
            <AttributeItem
              valueParser={'creativesCount'}
              value={creativesCount}
            />
          </AttributeList>
        }
      />
    </ScreenGo>
  );
};
export default PreviewColumn;
